import { AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { TResponse, TResponseWithQData } from "../../../types/common";
import { QData } from "../../../types/basic-type-list";
import { InsightPayload } from "@src/types/api/insight";

export async function saveInsight(
  data: InsightPayload
): Promise<AxiosResponse<TResponse<InsightPayload>>> {
  return axios.post<TResponse<InsightPayload>>(
    API_ENDPOINTS.SAVE_INSIGHT,
    data
  );
}

export async function listInsight(
  qData: QData
): Promise<AxiosResponse<TResponseWithQData<InsightPayload[]>>> {
  return axios.get<TResponseWithQData<InsightPayload[]>>(
    API_ENDPOINTS.LIST_INSIGHT,
    {
      params: qData,
    }
  );
}

export async function deleteInsight(
  payload: { id: string | string[] }
): Promise<AxiosResponse<TResponse<null>>> {
  return axios.post<TResponse<null>>(API_ENDPOINTS.DELETE_INSIGHT, payload);
}
